/* ============
 * Create Page
 * ============
 *
 * This is the page for adding product group.
 */
import { mapGetters } from 'vuex';
import materialService from './../../../../services/material';
import addSupplier from './../../supplier/quickCreate/quickCreate.vue';
import materialTypeService from './../../../../services/materialType';
import supplierService from './../../../../services/supplier';
import unitOfMeasureService from './../../../../services/unitOfMeasure';
import materialTransformer from './../../../../transformers/material';
import Forms from './../../../../utils/forms/forms';

export default {
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        description: {
          value: '',
          type: 'textarea',
        },
        materialTypeId: {
          value: '',
          type: 'select',
        },
        unitMeasureId: {
          value: '',
          type: 'select',
        },
        supplierId: {
          value: '',
          type: 'select',
        },
        minimumStockLevel: {
          value: '',
          type: 'number',
        },
      }),
    };
  },

  created() {
    this.form.setQuickForm('supplierId', addSupplier);

    Promise.all([
      materialTypeService.all(),
      supplierService.all(),
      unitOfMeasureService.all(),
    ]).then(() => {
      this.loading = false;
    });
  },

  computed: {
    ...mapGetters({
      materialTypes: 'allMaterialTypes',
      unitOfMeasures: 'allUnitOfMeasures',
      suppliers: 'allSuppliers',
    }),
  },

  methods: {
    /**
     * Method to store the product group.
     */
    store() {
      this.form.loading = true;
      const material = materialTransformer.send(this.form.data());
      materialService.store(material)
        .then(() => {
          this.form.loading = false;
          this.$message({
            message: this.$t('static.materials.create.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'production.materials.index',
          });
        }).catch((errors) => {
          this.form.loading = false;
          this.form.recordErrors(errors);
        });
    },
    camalize(str) {
      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
    },
  },

  watch: {
    materialTypes(types) {
      this.form.setOptions('materialTypeId', types.map(c => ({
        id: c.id,
        name: this.$t(`static.materials.types.${this.camalize(c.name)}`),
      })));
    },
    unitOfMeasures(units) {
      this.form.setOptions('unitMeasureId', units.items.map(c => ({
        id: c.id,
        name: this.$t(`static.materials.unitOfMeasures.${this.camalize(c.name)}`),
      })));
    },
    suppliers(suppliers) {
      this.form.setOptions('supplierId', suppliers.items);
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/materials/create/create.js